import React from 'react';
import Header from './Header.js';
import Footer from './Footer.js';

const App = React.createClass({
    propTypes: {
        children: React.PropTypes.object
    },
    render: function() {
        return (
            <div className="page-wrapper">
                <Header currentPage={process.env.BROWSER && window.location.pathname} />
                <div className="page-content">
                    {this.props.children}
                </div>
                <Footer currentPage={process.env.BROWSER && window.location.pathname} />
            </div>
        );
    }
});

export default App;



// WEBPACK FOOTER //
// ./src/js/containers/App.js